import React from 'react'
import { format } from 'date-fns'
import { useSelector } from 'react-redux'

// import Can from '../../../../../features/components/Can'
import PdfGeneration from '../../../../../features/components/PdfGeneration'
// import LineItemTikTokCreate from '../../../../../forms/Tiktok/LineItemForms/LineItemTikTokCreate'
// import LineItemGoogleCreate from '../../../../../forms/Google/LineItemForms/LineItemGoogleCreate'
// import LineItemFacebookCreate from '../../../../../forms/Facebook/LineItemForms/LineItemFacebookCreate'
// import LineItemDv360Create from '../../../../../forms/DV360/LineItemForms/LineItemDv360Create'
import DateRangeWithStaticList from '../../../../../features/components/DateRange/DateRangeWithStaticList'
import ExportAsCsvReport from '../../../../../forms/Facebook/ExportAsCsvReport'

import getReportPDFSections from './pdfGeneration'
import { getSelectedPlatform } from '../../../../../helpers/handlePlatformSelection'
import { getDateRangePDFReportLabel } from '../../../../../features/components/DateRange/helpers'

import { setCampaignsSummaryDateRange } from '../../../../../modules/actions/campaignsSummary'
import { campaignSelector } from '../../../../../modules/selectors/campaigns'
import { campaignsSummaryDateRangeSelector } from '../../../../../modules/selectors/campaignsSummary'
import { FACEBOOK_PLATFORM } from '../../../../../constants/selectLists/platformList'

const CampaignsSummaryFilters = () => {
  const selectedPlatform = getSelectedPlatform()

  const { id: campaignId, name: campaignName } = useSelector(campaignSelector)
  const savedDateRange = useSelector(campaignsSummaryDateRangeSelector)

  const dateRangeLabel = getDateRangePDFReportLabel(savedDateRange)

  return (
    <>
      <DateRangeWithStaticList
        setDateRangeAction={setCampaignsSummaryDateRange}
        dateRangeSelector={campaignsSummaryDateRangeSelector}
      />
      {selectedPlatform === FACEBOOK_PLATFORM && (
        <ExportAsCsvReport
          dateRangeSelector={campaignsSummaryDateRangeSelector}
          campaignsIds={[campaignId]}
          level="line_item"
        />
      )}

      <PdfGeneration
        title={campaignName}
        dateRangeLabel={dateRangeLabel}
        getReportPDFSections={getReportPDFSections}
        fileName={`Campaign ${campaignId} - generated ${format(new Date(), 'dd-MMM-yyyy')}`}
      />
      {/*<Can I="create" a="LineItem">*/}
      {/*  {selectedPlatform === FACEBOOK_PLATFORM && <LineItemFacebookCreate />}*/}
      {/*  {selectedPlatform === GOOGLE_PLATFORM && <LineItemGoogleCreate />}*/}
      {/*  {selectedPlatform === TIKTOK_PLATFORM && <LineItemTikTokCreate />}*/}
      {/*  {selectedPlatform === DV_360_PLATFORM && <LineItemDv360Create />}*/}
      {/*</Can>*/}
    </>
  )
}

export default CampaignsSummaryFilters
